import PropTypes from 'prop-types';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { createTheme } from 'visitor-ui-component-library/theme/createTheme';
import { setPrimaryColor, setTextOnPrimaryColor } from 'visitor-ui-component-library/theme/defaultThemeOperators';
import { DEFAULT_TEXT_COLOR, DEFAULT_HELP_TEXT_COLOR } from 'visitor-ui-component-library/theme/ColorConstants';
import { setTransparentOnBackgroundIconButton } from 'visitor-ui-component-library/button/theme/iconButtonThemeOperators';
import { jsx as _jsx } from "react/jsx-runtime";
const ThemeProvider = ({
  children,
  coloring: {
    accentColor,
    useDefaultColor
  }
}) => {
  const operators = [setPrimaryColor(accentColor)];
  if (useDefaultColor) {
    operators.push(setTextOnPrimaryColor(DEFAULT_TEXT_COLOR));
    operators.push(setTransparentOnBackgroundIconButton(DEFAULT_HELP_TEXT_COLOR));
  }
  return /*#__PURE__*/_jsx(StyledThemeProvider, {
    theme: createTheme(...operators),
    children: children
  });
};
ThemeProvider.propTypes = {
  children: PropTypes.node,
  coloring: PropTypes.object.isRequired
};
ThemeProvider.displayName = 'ThemeProvider';
export default ThemeProvider;